import i18n from 'i18n'
import * as msgTypes from 'models/iFrame/msgTypes'
import { getPathRegion, getBaseUrl } from 'models/location/selectors'
import { isProd, getTestingEnv } from 'utils/environment'
import { APP_ENV_PROD, APP_ENV_TESTING } from 'models/tracking/constants'

const geoHeaderNode = document.querySelector('#GeomagicalWindow .geoHeader')
if (geoHeaderNode) {
    geoHeaderNode.innerHTML = i18n.t('magicWindow.header')
}
const geoSubheaderNode = document.querySelector('#GeomagicalWindow .geoSubheader')
if (geoSubheaderNode) {
    geoSubheaderNode.innerHTML = i18n.t('magicWindow.subheader')
}

const geoHeaderButtonNode = document.querySelector('#GeomagicalWindow .geoHeaderButton')
if (geoHeaderButtonNode) {
    geoHeaderButtonNode.innerHTML = i18n.t('magicWindow.open magic window')
}

const geoCtaButtonNode = document.querySelector('#GeomagicalWindow .geoCtaButton')
if (geoCtaButtonNode) {
    geoCtaButtonNode.innerHTML = i18n.t('magicWindow.explore this room in 3D')
}

const geoCardHeaderNode = document.querySelector('#GeomagicalWindowCard .geoCardHeader')
if (geoCardHeaderNode) {
    geoCardHeaderNode.innerHTML = i18n.t('magicWindow.furnish this space in 3D')
}
const geoCardSubheaderNode = document.querySelector('#GeomagicalWindowCard .geoCardSubheader')
if (geoCardSubheaderNode) {
    geoCardSubheaderNode.innerHTML = i18n.t('magicWindow.explore your home design')
}

const geoCardCtaButtonNode = document.querySelector('#GeomagicalWindowCard .geoHeaderButton')
if (geoCardCtaButtonNode) {
    geoCardCtaButtonNode.innerHTML = i18n.t('magicWindow.try it now')
}

const PROD_COMPOSITION_IDS = {
    'us/en': '10824',
    'gb/en': '10825',
}

const REGION = getPathRegion()
const SCENE_ID = isProd ? '21127' : '41322'
const COMPOSITION_ID = isProd ? PROD_COMPOSITION_IDS[REGION] : '10647'

const isTestingEnv = getTestingEnv()

function trackGoogleAnalytics(action, label, options = {}) {
    if (window.sendEvent) {
        window.sendEvent({
            ...options,
            AppEnvironment: isTestingEnv ? APP_ENV_TESTING : APP_ENV_PROD,
            event_category: 'magic_window',
            event_action: action,
            event_label: label,
        })
    }
}

function makeModalWidth() {
    const iframeElement = document.getElementById('GeomagicalIFrame')
    iframeElement.classList.remove('fullWidth')
    iframeElement.classList.add('modalWidth')
}

function makeFullWidth() {
    const iframeElement = document.getElementById('GeomagicalIFrame')
    iframeElement.classList.add('fullWidth')
    iframeElement.classList.remove('modalWidth')
}

function closeMagicWindow() {
    document.getElementById('GeomagicalModal').style.display = 'none'
    const iframeElement = document.getElementById('GeomagicalIFrame')
    iframeElement.classList.remove('modalWidth')
    iframeElement.classList.remove('fullWidth')

    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0', 10) * -1)

    trackGoogleAnalytics('close', COMPOSITION_ID)
}

function onMessage(message) {
    const { data = {} } = message
    const { action, label } = data
    switch (data.type) {
        case msgTypes.MAGIC_WINDOW_CLOSE: {
            closeMagicWindow()
            break
        }
        case msgTypes.MAGIC_WINDOW_LOADED: {
            trackGoogleAnalytics('load_complete', COMPOSITION_ID)
            makeModalWidth()
            break
        }
        case msgTypes.MAGIC_WINDOW_MODAL_SCREEN: {
            makeModalWidth()
            break
        }
        case msgTypes.MAGIC_WINDOW_FULL_SCREEN: {
            makeFullWidth()
            break
        }
        case msgTypes.MAGIC_WINDOW_GA_TRACKING: {
            trackGoogleAnalytics(action, label)
            break
        }
        default: {
            // eslint-disable-next-line no-console
            console.log('Magic window message type not accounted for message: ', message)
            break
        }
    }
}

function openMagicWindow() {
    const magicWindowModal = document.getElementById('GeomagicalModal')
    let magicWindowIframe = document.getElementById('GeomagicalIFrame')
    if (!magicWindowIframe) {
        magicWindowIframe = document.createElement('iframe')
        magicWindowIframe.id = 'GeomagicalIFrame'
    }
    window.addEventListener('message', onMessage)
    const subCatalog = 'magicwindow'
    const canvasWidth = window.innerWidth

    const optionalTestingUrlParam = isTestingEnv ? '&testing=true' : ''
    // eslint-disable-next-line max-len
    const urlParams = `subCatalog=${subCatalog}&canvasWidth=${canvasWidth}${optionalTestingUrlParam}#${COMPOSITION_ID}/${SCENE_ID}`

    let source = `${getBaseUrl()}/magicWindow?${urlParams}`
    if (window.location.hostname === 'localhost') {
        source = `//localhost:1080/magicWindow.html?${urlParams}`
    }
    magicWindowIframe.src = source

    magicWindowModal.appendChild(magicWindowIframe)
    magicWindowModal.style.display = 'flex'

    document.body.style.top = `-${window.scrollY}px`
    document.body.style.position = 'fixed'

    trackGoogleAnalytics('open', COMPOSITION_ID)
}

const startButtons = document.querySelectorAll('.geoStartMagicWindow')
for (let i = 0, max = startButtons.length; i < max; i += 1) {
    startButtons[i].onclick = openMagicWindow
}

// To catch the browser close event
window.addEventListener('beforeunload', (event) => {
    const magicWindowModal = document.getElementById('GeomagicalModal')
    const isMagicWindowOpen = magicWindowModal.style.display === 'flex'

    if (isMagicWindowOpen) {
        // Cancel the event as stated by the standard.
        event.preventDefault()

        // Older browsers supported custom message
        // eslint-disable-next-line no-param-reassign
        event.returnValue = ''

        trackGoogleAnalytics('close', COMPOSITION_ID, { transport_type: 'beacon' })
    }
})
